export function getOnBoardingPrompt(template: string, onBoardForm: any): string {
    const homecity = `${onBoardForm?.home?.city ?? ""} ${onBoardForm?.home?.state ?? ""} ${onBoardForm?.home?.country ?? ""}`.trim();
    const travelwith = onBoardForm?.travelWith ?? "";
    const vibes = Array.isArray(onBoardForm?.lookingFor)
        ? onBoardForm.lookingFor.join(", ")
        : "";
    const budget = onBoardForm?.budget ?? "";

    // Replace placeholders in the template
    return template
        .replace("<homecity>", homecity)
        .replace("<travelwith>", travelwith)
        .replace("<comma-separated-list-of-selected-vibes>", vibes)
        .replace("<budget-rating>", budget);
}